export default function(type) {
  if (this.services.length > 0) {
    return this.services.filter(service => {
      return service.type == type;
    });
  }
  return null;
}
